import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-label',
  templateUrl: './ab-label.component.html',
  styleUrls: ['./ab-label.component.scss']
})
export class AbLabelComponent implements OnInit {

 @Input() element: any;

  constructor() { }

  ngOnInit(): void {
  }

}
